/*eslint-disable*/
//流程模块接口设置
import {
  postRequest,
  postRequestParams,
  getRequest,
  fileUpload,
  postDataParams
} from '@/api/request' // 导入request中创建的axios实例
const player = {
  activityDetails: param => { //活动详情页接口-APP端-肖东
    return getRequest('app/activity/activityDetailsApp', param)
  },
  addActivityAnswer: param => { //进入活动详情时活动回答信息新增接口-APP端-肖东
    return postRequest('app/activity/addActivityAnswer', param)
  },
  addActivityAnswerItem: param => { //活动问题回答新增接口-APP端-肖东
    return postRequest('app/activity/addActivityAnswerItem', param)
  },
  activitySingUp: param => { //活动报名接口-APP端-肖东
    return postRequest('app/activity/activitySingUp', param)
  },
  activityBallotStatistics: id => { //活动投票人数统计接口-肖东
    return getRequest('app/activity/activityBallotStatistics/' + id, {})
  },
}
export default {
  player
}